




































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";
import ReimburseMeForm from "@/employee/components/ReimburseMeForm.vue";
import CashExpensesGraphWidget from "@/employee/components/widgets/CashExpensesGraphWidget.vue";
import ReimbursementHistoryTable from "@/shared/components/reimbursement/ReimbursementHistoryTable.vue";
import Button from "@/shared/components/ui/Button.vue";
import moment from "moment";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    ReimburseMeForm,
    CashExpensesGraphWidget,
    ReimbursementHistoryTable,
    Button
  }
})
export default class ReimburseMe extends Vue {
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  hsaDailyBalanceStore = useHsaDailyBalanceStore();
  custodianSettingsStore = useCustodianSettingsStore();

  barChartSize = {
    height: 190,
    width: 220
  };

  @Prop()
  prefill: number;

  formatCurrency = formatCurrency;

  mounted () {
    if (!this.expenseBalanceSummaryStore.isSummaryLoaded) {
      this.expenseBalanceSummaryStore.loadState();
    }
    this.hsaDailyBalanceStore.setCurrentEndDateKey(moment().format("YYYYMMDD"));
    this.hsaDailyBalanceStore.loadPredictedDailyBalances();
    this.hsaDailyBalanceStore.loadBalanceOnFile();
  }

  get cashDisplay () {
    return this.cashBalance < 0 ? 0 : this.cashBalance;
  }

  get cashBalance (): number {
    return this.hsaDailyBalanceStore.getInstantBalance.amount || this.hsaDailyBalanceStore.balanceOnFileAmount;
  }

  get unreimbursedDisplay () {
    return this.expenseBalanceSummaryStore.unreimbursed < 0 ? 0 : this.expenseBalanceSummaryStore.unreimbursed;
  }

  get isDataLoaded () {
    return this.expenseBalanceSummaryStore.isSummaryLoaded && this.hsaDailyBalanceStore.balanceOnFileLoaded;
  }
}
